<template>
	<div>
		<section
				:class="[
						textHorizontal ? 'text-horizontal' : 'text-vertical',
						isMobile === true ? 'mobile': '',
						isSummary === true ? 'summary':'',
						isContent === true ? 'content': '',
						isFireFox ? 'prefix-firefox' : ''
						]"
				class="input-contenteditable"
				:field-name="fieldName"
				contenteditable="true"
				@blur="cutString"
				@input="updateState"
				@keydown="handleKeyDown($event)"
				v-html="tmpText"
		/>

		<div
				class="place-holder place-holder-vertical"
				:class="{'hide': isHidePlaceholder}"
				v-html="placeholder"></div>

		<div class="charCount" v-if="isMobile === true" v-text="`(${count}/${maxLength})`"></div>
	</div>
</template>

<script>
	// supporters
	import KeyHandlingMixin from '../../mixins/keyHandling.mixin'

	export default {
		name: 'InputText',

		mixins: [KeyHandlingMixin],

		data () {
			return {
				count: 0
			}
		},

		computed: {
			isFireFox () {
				return typeof InstallTrigger !== 'undefined'
			},
		}
  }
</script>

<style scoped lang="scss">
	.container section.input-contenteditable.text-horizontal.mobile{
		padding-top: 17px;

		&.prefix-firefox{
			padding-top: 17px;
		}
	}
</style>
